import {defineStore} from "pinia";
import {QrBatchType, QrTable} from "@/scripts/types/qr";
import {useToast} from "vue-toastification";
import {saveBatchQr} from "@/scripts/api/qr";

const toast = useToast();

export const useBatchQr = defineStore('useBatchQr', {
    actions: {
        async saveBatchQr(
            type: QrBatchType,
            data: QrTable | File,
            style: any,
            pixel?: string
        ) {
            try {
                return await saveBatchQr({
                    type: type,
                    data: data,
                    style: style,
                    pixel: pixel
                })
            } catch (error: any) {
                toast.error(error.response?.data.message);
            }
        }
    }
})